export { default } from "./ResourcesSharedWithMe";
